module.exports = __webpack_public_path__ + "static/img/Gacha13.2eed49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha13.png
// module id = BZLA
// module chunks = 1